module.exports = __webpack_public_path__ + "img/icon_successful_2.76ec1062.png";